<template>
  <div class="major">
    <div class="typeOf">类型</div>
    <div class="vanTabsItem">
      <van-tabs v-model="active" @change="() => changeTabs(active)">
        <van-tab v-for="(tab, index) in tabArray" :key="index" :title="tab">
          <div class="padding20X paddingX14 van-bgcolor-white">
            <!-- tab1 -->
            <template v-if="active === 0">
              <van-form ref="ruleForm" class="tab1Form castForm">
                <p class="tab1Form-item-label">币种<span>(必填)</span></p>
                <cu-field
                  v-model="cast.currency"
                  name="currency"
                  placeholder="请输入代币代码，例如PIPE"
                  :rules="[
                    { required: true, message: '请输入币种' },
                    {
                      validator: validatorWithCurrency,
                      message: '请输入最多15个英文字母字符'
                    }
                  ]"
                />
                <p class="tab1Form-item-label">ID</p>
                <cu-field
                  v-model="cast.id"
                  name="id"
                  placeholder="请输入ID"
                  :rules="[{ required: true, message: '请输入币种' }]"
                />
                <p class="tab1Form-item-label">数量<span>(必填)</span></p>
                <cu-field
                  v-model="cast.amount"
                  name="amount"
                  placeholder=" 请输入数量"
                  :rules="[{ required: true, message: '请输入数量' }]"
                />
                <div class="tab1Form-item-label selectAddress">
                  <div>{{ inpWayText }}接收地址<span>(必填)</span></div>
                  <div @click="changeInpAdWay()">
                    <img src="../../../assets/images/dmtAorrow.png" />
                    {{ selectWayText }}接收地址
                  </div>
                </div>
                <!-- <div class="tab1Form-item-value"> -->
                <van-field
                  v-if="isSelect"
                  v-model="cast.address"
                  name="address"
                  readonly
                  clearable
                  :rules="[{ required: true, message: '请选择地址' }]"
                  placeholder="请选择地址"
                  @click="showAdSelect"
                >
                  <template #button>
                    <van-icon name="arrow-down" />
                  </template>
                </van-field>
                <cu-field
                  v-else
                  v-model="cast.address"
                  name="address"
                  placeholder="请输入地址"
                  :rules="[{ required: true, message: '请输入地址' }]"
                />
                <!-- </div> -->
              </van-form>
            </template>
            <!-- tab2 -->
            <template v-else-if="active === 1">
              <!-- 转移 -->
              <van-form ref="ruleForm" class="tab1Form transfer">
                <div class="form-item">
                  <p class="tab1Form-item-label">币种</p>
                  <div class="tab1Form-item-value">
                    <van-button @click="showTransferSelect('currency')">{{
                      transfer.currency ? transfer.currency : "选择币种"
                    }}</van-button>
                  </div>
                </div>
                <div class="form-item">
                  <p class="tab1Form-item-label">转移UTXO</p>
                  <div class="tab1Form-item-value">
                    <van-button @click="showTransferSelect('utxo')">{{
                      transfer.utxo ? transfer.utxo : "选择UTXO"
                    }}</van-button>
                  </div>
                </div>
                <div class="form-item">
                  <p class="tab1Form-item-label">数量<span>(必填)</span></p>
                  <cu-field
                    v-model="transfer.amount"
                    name="amount"
                    placeholder="输入数量"
                    :rules="[{ required: true, message: '请输入数量' }]"
                  />
                </div>
                <div class="tab1Form-item-label selectAddress">
                  <div>{{ inpWayText }}接收地址<span>(必填)</span></div>
                  <div @click="changeInpAdWay()">
                    <img src="../../../assets/images/dmtAorrow.png" />
                    {{ selectWayText }}接收地址
                  </div>
                </div>
                <!-- <div class="tab1Form-item-value"> -->
                <van-field
                  v-if="isSelect"
                  v-model="transfer.address"
                  name="address"
                  readonly
                  clearable
                  :rules="[{ required: true, message: '请选择地址' }]"
                  placeholder="请选择地址"
                  @click="showAdSelect"
                >
                  <template #button>
                    <van-icon name="arrow-down" />
                  </template>
                </van-field>
                <cu-field
                  v-else
                  v-model="transfer.address"
                  name="address"
                  placeholder="请输入地址"
                  :rules="[{ required: true, message: '请输入地址' }]"
                />
                <!-- </div> -->
              </van-form>
            </template>
            <!-- tab3 -->
            <template v-else-if="active === 2">
              <!-- 部署 -->
              <van-form ref="ruleForm" class="tab1Form deployForm">
                <p class="tab1Form-item-label">币种<span>(必填)</span></p>
                <cu-field
                  v-model="deploy.currency"
                  name="currency"
                  placeholder="输入代币代码，例如PIPE"
                  :rules="[
                    { required: true, message: '请输入币种' },
                    {
                      validator: validatorWithCurrency,
                      message: '请输入最多15个英文字母字符'
                    }
                  ]"
                />
                <p class="tab1Form-item-label">ID</p>
                <cu-field
                  v-model="deploy.id"
                  name="id"
                  placeholder="请输入ID"
                  :rules="[{ required: true, message: '请输入币种' }]"
                />
                <p class="tab1Form-item-label">发行总量<span>(必填)</span></p>
                <cu-field
                  v-model="deploy.amount"
                  name="amount"
                  placeholder="请输入发行总量"
                  :rules="[{ required: true, message: '请输入发行总量' }]"
                />
                <p class="tab1Form-item-label">单次锻造上限</p>
                <van-field
                  v-model="deploy.count"
                  name="count"
                  placeholder="请输入发行总量"
                />
                <div class="tab1Form-item-label selectAddress">
                  <div>{{ inpWayText }}接收地址<span>(必填)</span></div>
                  <div @click="changeInpAdWay()">
                    <img src="../../../assets/images/dmtAorrow.png" />
                    {{ selectWayText }}接收地址
                  </div>
                </div>
                <!-- <div class="tab1Form-item-value"> -->
                <van-field
                  v-if="isSelect"
                  v-model="deploy.address"
                  name="address"
                  readonly
                  clearable
                  :rules="[{ required: true, message: '请选择地址' }]"
                  placeholder="请选择地址"
                  @click="showAdSelect"
                >
                  <template #button>
                    <van-icon name="arrow-down" />
                  </template>
                </van-field>
                <cu-field
                  v-else
                  v-model="deploy.address"
                  name="address"
                  placeholder="请输入地址"
                  :rules="[{ required: true, message: '请输入地址' }]"
                />
                <!-- </div> -->
              </van-form>
            </template>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { Tab, Tabs, Field, Icon, Popup, Button, Form } from "vant";
import cuField from "./cuField.vue";

const textMaps = {
  true: "选择",
  false: "输入"
};
const refMaps = {
  0: "castRef",
  1: "transferRef",
  2: "deployRef"
};

export default {
  name: "Inscription",
  components: {
    vanTab: Tab,
    vanTabs: Tabs,
    VanForm: Form,
    VanField: Field,
    VanIcon: Icon,
    VanPopup: Popup,
    VanButton: Button,
    CuField: cuField
  },
  props: {
    isShowSelectAd: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tabArray: ["铸造", "转移", "部署"],
      active: 0,
      isSelect: true,
      formRef: null,
      // temp: {
      //   currency: "",
      //   id: "0",
      //   amount: ""
      // },
      cast: {
        currency: "",
        id: "0",
        amount: "",
        address: ""
      },
      transfer: {
        currency: "",
        utxo: "",
        amount: "",
        address: ""
      },
      deploy: {
        currency: "",
        id: "0",
        amount: "",
        count: "",
        address: ""
      }
    };
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {},
  computed: {
    ...mapGetters([
      "token",
      "styleType",
      "isDirection",
      "languageName",
      "language",
      "isApp"
    ]),
    inpWayText() {
      return textMaps[this.isSelect];
    },
    selectWayText() {
      return textMaps[!this.isSelect];
    },
    dataName() {
      return refMaps[this.active].split("Ref")[0];
    }
  },
  watch: {},
  methods: {
    // 地址输入方式切换
    changeInpAdWay() {
      this.isSelect = !this.isSelect;
    },
    // 打开地址选择
    showAdSelect() {
      const currentSelect = this[this.dataName].address
      this.$emit("showAdPopUp", currentSelect);
    },
    // 币种和utxo的选择
    showTransferSelect(type) {
      const currentSelect = this[this.dataName][type];
      this.$emit("showTransferPopUp", type, currentSelect);
    },
    // 重置表单校验
    changeTabs(index) {
      const formRef = this.$refs.ruleForm[index];
      formRef && formRef.resetValidation();
    },
    // 弹出选择确定后回调回填
    changeSelectData(field, val) {
      this[this.dataName][field] = val;
    },
    getTabFormValues() {
      return this[this.dataName];
    },
    // 提交(下一步的按钮操作)
    submit() {
      let index = this.active;
      const formRefs = this.$refs.ruleForm;
      // 只有一种情况获取到的ref个数和active对不上，就是从1个切换到第三个
      if (this.active + 1 !== formRefs.length && formRefs.length !== 3) {
        index = 1;
      }
      return new Promise((resolve, reject) => {
        formRefs[index]
          .validate()
          .then(() => {
            resolve(this[this.dataName]);
          })
          .catch(() => {
            resolve(false);
          });
      });
    },
    // 币种校验
    validatorWithCurrency(val) {
      return /^[a-zA-Z]+$/.test(val) && val.trim().length <= 15;
    },
    // 输入框字数校验
    validatorWithNum(val, num = 50) {
      return val.trim().length > num;
    }
  }
};
</script>

<style lang="scss" scoped>
// @import '../../assets/css/variableName';
@import "../../../assets/css/variableName.scss";
@import "../../../style/mixin";
.major {
  // margin-top: torem(5);
  .typeOf {
    margin-top: torem(20);
    margin-bottom: torem(8);
    height: torem(16.5);
    font-size: torem(14);
    font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.6);
    line-height: torem(16.5);
  }
  .vanTabsItem {
    width: torem(343);
    /deep/ .van-tabs__content {
      padding: 0;
    }
    /deep/ .van-tabs__nav {
      padding-left: 0;
    }
    /deep/ .van-tabs__nav--line {
      display: flex;
      justify-content: space-between;
      background-color: #f2f2f2;
      border-radius: torem(6);
    }
    /deep/ .van-tab {
      min-width: torem(109);
      color: rgba(0, 0, 0, 0.4);
      padding-left: torem(2);
      justify-content: center;
    }
    /deep/ .van-tab__text--ellipsis {
      font-size: torem(14);
      font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
      font-weight: 400;
      // color: rgba(0,0,0,0.4);
    }
    /deep/ .van-tab--active {
      background-color: #ffffff;
      margin: torem(4);
      border-radius: torem(8);
      color: rgba(0, 0, 0, 0.9);
    }
    /deep/ .van-tabs__line {
      background-color: transparent;
    }
    // /deep/ .van-tabs__nav .van-tabs__nav--line{
    //     background-color: red;
    // }
  }
  .tab1Form {
    margin-top: torem(20);
    .form-item {
      margin-top: torem(20);
    }
    /deep/ .van-cell {
      margin-bottom: torem(20);
      // height: torem(66);
    }
    /deep/ .van-field__control {
      width: torem(310);
      height: torem(40);
      line-height: torem(40);
      border-radius: torem(2);
      font-size: torem(16);
      @include sc(torem(14), #333);
      padding: 0 torem(15);
      background-color: #fff;
      // &:focus {
      //   border-color: #ffc72b;
      // }
    }
    // /deep/ .van-field__control:focus {
    //   border-color: #ffc72b!important;
    // }
    /deep/ .van-field__body {
      border: torem(0.5) solid #dcdfe6;
    }
    /deep/ .van-field__error-message {
      font-size: torem(10);
    }
    .selectAddress {
      display: flex;
      justify-content: space-between;
      font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
      font-weight: 400;
      div {
        &:nth-child(1) {
          color: rgba(0, 0, 0, 0.6);
          font-size: torem(14);
          span {
            font-size: torem(10);
          }
        }
        &:nth-child(2) {
          display: flex;
          align-items: center;
          color: #007aff;
          font-size: torem(12);
          img {
            width: torem(16);
            height: torem(16);
            margin-right: torem(4);
          }
        }
      }
      /deep/ .van-icon {
        font-size: torem(12);
      }
    }
    .tab1Form-item {
      margin-bottom: torem(20);

      // input {
      //   // width: 100%;
      //   width: torem(343);
      //   height: torem(40);
      //   line-height: torem(40);
      //   border-radius: torem(2);
      //   border: torem(0.5) solid #dcdfe6;
      //   @include sc(torem(14), #333);
      //   padding: 0 torem(15);
      //   background-color: #fff;

      //   // &:focus {
      //   //   border-color: #ffc72b;
      //   // }
      // }
      // /deep/ .van-field__control {
      //   width: torem(310);
      //   height: torem(40);
      //   line-height: torem(40);
      //   border-radius: torem(2);

      //   @include sc(torem(14), #333);
      //   padding: 0 torem(15);
      //   background-color: #fff;

      //   // &:focus {
      //   //   border-color: #ffc72b;
      //   // }
      // }
      /deep/ .van-field__body {
        // border: torem(0.5) solid #dcdfe6;
      }
      &-label {
        font-size: torem(14);
        color: rgba(0, 0, 0, 0.6);
        margin-bottom: torem(8);
        span {
          font-size: torem(10);
        }
      }

      &-value {
        font-size: torem(12);
        margin-bottom: torem(5);

        .error-border {
          border-color: #f56c6c;
        }

        .phoneNumber {
          width: calc(100% - #{torem(110)});
        }

        .service {
          margin-left: torem(3);
          @include sc(torem(12), #333);
          line-height: 1.2;

          a {
            color: #ffc72b;
          }
        }

        .error-tip {
          margin-top: torem(8);
          @include sc(torem(12), #d35d5d);
        }

        .disabled-input {
          background-color: #eef1f5;
          color: #999999;
        }
      }
      // .error-msg {
      //   @include sc(torem(12), #d35d5d);
      // }
    }
    /deep/ .van-field--error .van-field__control::placeholder {
      color: #ccc !important;
    }
  }
  .transfer {
    /deep/ .van-button {
      width: 100%;
      height: torem(40);
      font-size: torem(12);
      color: #ffc72b;
      background-color: rgba(255, 199, 43, 0.05);
      border-color: #ffc72b;
    }
  }
  .deployForm {
    padding-bottom: torem(60);
  }
  /deep/ .van-field {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/InscriptionArea/compontents/dmtTab.vue